<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="[]"
      :items="list"
      :filter-names="filterNames"
      show-date
      :date-validation="false"
      date-option-type="datetime"
      @filterOption="onFiltersChange"
    >
      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-autocomplete
            v-model="customFilters.vendor_id"
            filled
            dense
            :loading="isVendor"
            :items="vendorList"
            item-text="child_tenant_name"
            item-value="child_tenant"
            :label="$t('select_vendor')"
            clearable
            @change="onVendorChange"
          />
        </v-card>
        <v-card class="allVehicleSelect">
          <v-autocomplete
            v-model="customFilters.route_ids"
            filled
            dense
            :loading="isRoute"
            :items="routeList"
            item-text="name"
            item-value="id"
            :label="$t('select_routes')"
            clearable
            multiple
            @change="onRouteChange"
          >
            <template v-slot:selection="data">
              <span
                v-if="data.index === 0"
                class="selected"
              >
                <span>{{ data.item.name }}</span>
              </span>
              <span
                v-if="data.index === 1"
                class="grey--text text-caption"
              >
                (+{{ customFilters.route_ids.length - 1 }} others)
              </span>
            </template>
          </v-autocomplete>
        </v-card>
        <v-card class="allVehicleSelect">
          <v-autocomplete
            v-model="customFilters.vehicle_ids"
            filled
            dense
            :loading="isVehicle"
            :items="vehicleList"
            item-text="name"
            item-value="id"
            :label="$t('select_vehicles')"
            clearable
            multiple
            @change="fetchData"
          >
            <template v-slot:selection="data">
              <span
                v-if="data.index === 0"
                class="selected"
              >
                <span>{{ data.item.name }}</span>
              </span>
              <span
                v-if="data.index === 1"
                class="grey--text text-caption"
              >
                (+{{ customFilters.vehicle_ids.length - 1 }} others)
              </span>
            </template>
          </v-autocomplete>
        </v-card>
      </template>
      <!-- add Filters -->

      <!-- Transit Row -->
      <template #dataTable>
        <div
          v-if="list.length > 0"
          class="data-wrapper v-data-table"
        >
          <div
            v-for="(row, i) in list"
            :key="i"
          >
            <transit-row
              :index-key="`transit-${i}`"
              :loading="isLoading"
              :items="row"
              :is-open="activeIndex === i"
              @toggle="onToggleRow(i)"
            />
          </div>
        </div>
        <v-data-table
          v-else
          :loading="isLoading"
          hide-default-footer
        />
      </template>
      <!-- Transit Row -->

      <!-- Action Modals -->
      <!-- <template #actionModals> </template> -->
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { debounce } from "lodash";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    TransitRow: () => import("../utils/TransitRow.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      filters: {},
      subFilters: {},
      //
      customFilters: {},

      activeIndex: null, // 👈 currently open row
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "transitReports/getLoading",
      meta: "transitReports/meta",
      list: "transitReports/getList",
      //
      isVendor: "tenantsRelationship/getLoading",
      vendorList: "tenantsRelationship/getList",
      //
      isRoute: "geofence/getLoading",
      routeList: "geofence/getRouteList",
      //
      isVehicle: "vehicles/getIsLoadingVehicles",
      vehicleList: "vehicles/getVehiclesList",
      //
      // for tenant_tech
      // tenantsList: "tenantsManagement/getTenantOptions",
    }),
    // getVehilceTech() {
    //   const row = this.tenantsList.find((r) =>
    //     this.options.is_independent_fleet
    //       ? r.id == this.options.fleetId
    //       : r.id == this.options.tenant_id
    //   );
    //   return row?.vehicle_tech || null;
    // },

    filterNames() {
      return [];
    },
    //
  },
  watch: {
    "options.tenant_id": {
      handler: function (v) {
        this.customFilters = {};
        this.onTenantChange({ tenant_id: v });
      },
    },
    "options.fleetId": {
      handler: function (v) {
        this.customFilters = {};
        this.onTenantChange({ tenant_id: v });
      },
    },

    options() {
      this.fetchData();
    },
  },
  beforeDestroy() {
    const params = {
      name: "transit_reports",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  mounted() {
    setTimeout(() => {
      const tId = this.options?.tenant_id || this.options?.fleetId;
      this.onTenantChange({ tenant_id: tId });
      //
      if (this.$route?.query?.vendor_id) {
        this.customFilters.vendor_id = parseInt(this.$route?.query?.vendor_id);
        this.onVendorChange(this.customFilters.vendor_id);
      }
      if (this.$route?.query?.route_ids) {
        this.customFilters.route_ids = this.$route?.query?.route_ids?.map((r) =>
          parseInt(r)
        );
        this.onRouteChange(this.customFilters.route_ids);
      }
      if (this.$route?.query?.vehicle_ids) {
        this.customFilters.vehicle_ids = this.$route?.query?.vehicle_ids?.map(
          (r) => parseInt(r)
        );
        this.onVehicleChange(this.customFilters.vehicle_ids);
      }
    }, 500);
  },

  methods: {
    fetchData: debounce(async function () {
      this.activeIndex = null;
      const params = {
        ...this.options,
        ...this.customFilters,
        abort_signal: true,
      };
      if (params.vendor_id) {
        if (params.tenant_id) {
          params.tenant_id = params.vendor_id;
        }
        if (params.fleetId) {
          params.fleetId = params.vendor_id;
        }
      }
      await this.$store.dispatch("transitReports/list", params).then(() => {
        // this.getCityName(res?.data);

        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    }, 1500),

    onTenantChange(params) {
      this.getVendorList(params);
      this.getRouteList(params);
      this.getVehicleList(params);
    },
    //
    getVendorList: debounce(async function (params) {
      await this.$store.dispatch("tenantsRelationship/list", {
        parent_tenant_id: params?.tenant_id,
      });
    }, 500),
    getRouteList: debounce(async function (params) {
      await this.$store.dispatch("geofence/routeList", params);
    }, 500),
    getVehicleList: debounce(async function (params) {
      await this.$store.dispatch("vehicles/list", {
        ...params,
        compare_route: true,
      });
    }, 500),
    //
    onVendorChange(v) {
      delete this.customFilters.route_ids;
      delete this.customFilters.vehicle_ids;

      const params = { tenant_id: v };
      this.getRouteList(params);
      this.getVehicleList(params);
      this.fetchData();
    },
    onRouteChange(v) {
      delete this.customFilters.vehicle_ids;
      const params = { route_ids: v, tenant_id: this.customFilters.vendor_id };
      this.getVehicleList(params);
      this.fetchData();
    },
    //
    onToggleRow(index) {
      // It will close when user click same row
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>
<style lang="sass" scoped>
.data-wrapper
  overflow-y: auto
</style>
